import React, { Component } from 'react'
import '../css/range.css'
import '../css/App.css'
import Menu from '../Menu'

import { LocaleProvider } from 'react-localizer'

const source = require('../locale/languages/fr')

class App extends Component {
  render () {
    return (
      <LocaleProvider language="fr" source={source} importer={(language) => {
        return import(`../locale/languages/${language}`)
      }}>
        <div className="App">
          <Menu/>
        </div>
      </LocaleProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js